import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

import { Col as ColCommon, Row as RowCommon } from '~/src/features/center/common/styled';

export const Col = styled(ColCommon)`
    padding-right: .8rem;
    padding-left: .8rem;
`;

export const ColButton = styled(ColCommon)`
    padding-right: 0;
    padding-left: 0;
`;

export const RowButton = styled(RowCommon)`
    margin-left: 0;
    margin-right: 0;
`;

export const Row = RowCommon;

export const RowMiddle = styled(FlexBoxRow)`
    width: 100%;
    margin-top: 111px;

    @media (max-width: ${breakPoints.mobile}) {
        width: auto;
        position: absolute;
        top: 414px;
        left: 0;
        right: 0;
        margin-right: 0;
        margin-left: 0;
        margin-top: -10px;
    }

    @media (max-width: 535px) {
        top: 300px;
     }
`;

export const Title = styled.h1`
    ${FONTS.H1};
    max-width: 695px;
    margin: 8px 0 0;
    text-transform: uppercase;

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.H2};
    }

    @media (max-width: ${breakPoints.mobile}) {
        color: ${COLORS.black};
        margin-top: 46px;
        max-width: 100%;
        margin-right: 12px;
    }
`;

export const Text = styled.div`
    ${FONTS.M};
    max-width: 502px;
    margin: 12px 0 0;
    color: ${COLORS.black};

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.S};
        max-width: 400px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.XS};
        max-width: 100%;
        color: ${COLORS.black};
        margin-right: 12px;
    }
`;

export const Form = styled.div`
    display: block;
    max-width: 534px;
    margin-top: 15px;
    position:relative;

    @media (max-width: ${breakPoints.mobile}) {
        margin-top: 20px;
        max-width: 100%;
    }
`;

export const Button = styled(BaseButton)`
    width: 248px;
    height: 48px;
    z-index: 8;
    padding: 9px 24px;

    @media (max-width: ${breakPoints.mobile}) {
        width: 100%;
        margin-bottom: 12px;
    }
`;
